import React, { useEffect, useState } from 'react';
import styles from './DENTDentalCross.module.scss';
import ToggleButtons from '../../../../Components/ToggleButtons/ToggleButtons';
import DENTWrapper from '../DENTWrapper/DENTWrapper';
import { OverviewMode } from '../../Enums/OverviewMode.enum';
import { useDENTContext } from '../../Services/DENTContext';
import DENTDentalCrossActions from './DENTDentalCrossActions';
import useNotification from '../../../../Hooks/useNotification.hook';
import DENTUpcomingMedicalExaminations from '../DENTUpcomingMedicalExaminations/DENTUpcomingMedicalExaminations';

interface OverviewModeOptions {
	value: OverviewMode;
	label: string;
	openQuickSelect?: boolean;
	openAdjustmentMode?: boolean;
}

const TOOTH_DETAIL_OPTIONS: OverviewModeOptions[] = [
	{
		value: OverviewMode.DEFAULT,
		label: 'patientTreatment.meddiDENT.dentalCross.overview',
	},
	{
		value: OverviewMode.QUICK_SELECT,
		label: 'patientTreatment.meddiDENT.dentalCross.quickSelect',
		openQuickSelect: true,
	},
	{
		value: OverviewMode.PERIODONTAL,
		label: 'patientTreatment.meddiDENT.dentalCross.periodont',
		openAdjustmentMode: true,
	},
	{
		value: OverviewMode.PATHOLOGY,
		label: 'patientTreatment.meddiDENT.dentalCross.pathology',
		openAdjustmentMode: true,
	},
	{
		value: OverviewMode.RESTORATION,
		label: 'patientTreatment.meddiDENT.dentalCross.restoration',
		openAdjustmentMode: true,
	},
];

const DENTDentalCross = () => {
	const {
		setAdjustmentMode,
		setOverviewMode,
		setQuickSelectMode,
		setActiveTooth,
		overviewMode,
		activeMedicalExaminationId,
		medicalExaminationNotificationShown,
		setMedicalExaminationNotificationShown,
	} = useDENTContext();
	const [selectedOption, setSelectedOption] = useState<OverviewModeOptions>(
		TOOTH_DETAIL_OPTIONS.find(option => option.value === overviewMode) ||
			TOOTH_DETAIL_OPTIONS[0],
	);
	const { showNotificationWarning } = useNotification();

	useEffect(() => {
		if (activeMedicalExaminationId && !medicalExaminationNotificationShown) {
			showNotificationWarning({
				content:
					'patientTreatment.meddiDENT.dentalCross.dentitionVisitInProgress',
			});
			setMedicalExaminationNotificationShown(true);
		}
	}, []);

	const handleChangeView = (option: OverviewModeOptions) => {
		setSelectedOption(option);
		setOverviewMode(option.value);

		if (option.value === OverviewMode.DEFAULT) {
			setAdjustmentMode(false);
			setQuickSelectMode(false);
			setActiveTooth(undefined);
		}

		if (option.openQuickSelect) {
			setAdjustmentMode(false);
			setQuickSelectMode(true);
		}

		if (option.openAdjustmentMode) {
			setQuickSelectMode(false);
			setAdjustmentMode(true);
		}
	};

	return (
		<div className={styles.container}>
			<ToggleButtons<OverviewModeOptions>
				options={TOOTH_DETAIL_OPTIONS}
				selectedOption={selectedOption}
				onChange={handleChangeView}
			/>
			<DENTDentalCrossActions />
			<DENTWrapper />
			<DENTUpcomingMedicalExaminations />
		</div>
	);
};

export default DENTDentalCross;
